// extracted by mini-css-extract-plugin
export var developerInfo = "DeveloperInfo-module--developerInfo--LiOKe";
export var developerInfo__listItem = "DeveloperInfo-module--developerInfo__listItem--3yQWV";
export var developerInfo__name = "DeveloperInfo-module--developerInfo__name--zgSY8";
export var developerInfo__job = "DeveloperInfo-module--developerInfo__job--GkPKn";
export var developerInfo__description = "DeveloperInfo-module--developerInfo__description--j4lOq";
export var developerInfo__textContainer = "DeveloperInfo-module--developerInfo__textContainer--RHTPo";